﻿import {isNullOrEmpty, translation} from "@2d-front-monorepo/core";
import {MvvmValidation, MvvmValidationResult} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {useMemo} from "react";

export default function usePasswordRequiredPolicy(validateRequirements: boolean): MvvmValidation<string> {
	return useMemo<MvvmValidation<string>>(() => {
		const result: MvvmValidation<string> = {
			required: translation(PermitTranslations.validation__password__required)
		}

		if (!validateRequirements) {
			return result;
		}

		result.validate = function (password: string | undefined): MvvmValidationResult | undefined {
			const minLength = 10;
			if (isNullOrEmpty(password) || password.length < minLength) {
				return {
					error: translation(PermitTranslations.validation__password_rules__01_requirement, {value: minLength}),
					type: "password-01-requirement"
				};
			}

			if (isNullOrEmpty(password) || !(/[a-z]/.test(password) && /[A-Z]/.test(password))) {
				return {
					error: translation(PermitTranslations.validation__password_rules__02_requirement),
					type: "password-02-requirement"
				};
			}

			if (isNullOrEmpty(password) || !(password.match(/\w/) && password.match(/\d/))) {
				return {
					error: translation(PermitTranslations.validation__password_rules__03_requirement),
					type: "password-03-requirement"
				};
			}

			if (isNullOrEmpty(password) || !password.match(/[!@#$%^&*()_+{}|:"<>.?]/)) {
				return {
					error: translation(PermitTranslations.validation__password_rules__04_requirement),
					type: "password-04-requirement"
				};
			}

			return undefined;
		}

		return result;
	}, [validateRequirements]);
}
